// ============================================================
// INSTANT PAGE PREFETCHER
// User hovers a link → we start loading that page in background
// By the time they click, page is already downloaded = feels instant
// ============================================================
(function() {
  var prefetched = new Set();
  var HOVER_DELAY = 65; // ms - enough to confirm intentional hover

  function prefetch(url) {
    if (prefetched.has(url)) return;
    prefetched.add(url);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function isValidLink(el) {
    if (!el || el.tagName !== 'A') return false;
    var href = el.href;
    if (!href || href === '' || href === '#') return false;
    // Only prefetch same-origin pages
    if (el.origin !== location.origin) return false;
    // Skip cart, account, logout, admin
    if (/\/(cart|account\/logout|admin)/.test(el.pathname)) return false;
    // Skip file downloads
    if (/\.(pdf|zip|png|jpg|jpeg|webp|gif|svg)$/.test(el.pathname)) return false;
    return true;
  }

  var hoverTimer = null;

  document.addEventListener('mouseover', function(e) {
    var el = e.target.closest('a');
    if (!isValidLink(el)) return;
    hoverTimer = setTimeout(function() {
      prefetch(el.href);
    }, HOVER_DELAY);
  }, { passive: true });

  document.addEventListener('mouseout', function(e) {
    if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
  }, { passive: true });

  // Touch: prefetch on touchstart (fires before click)
  document.addEventListener('touchstart', function(e) {
    var el = e.target.closest('a');
    if (!isValidLink(el)) return;
    prefetch(el.href);
  }, { passive: true });
})();

// ============================================================
// PAGE LOADING PROGRESS BAR
// Thin bronze bar at top on click — gives instant visual feedback
// ============================================================
(function() {
  var bar = document.createElement('div');
  bar.id = 'ps-progress-bar';
  bar.style.cssText = 'position:fixed;top:0;left:0;width:0;height:3px;background:#B8956A;z-index:99999;transition:width 0.3s ease,opacity 0.4s ease;pointer-events:none;opacity:0;';
  document.body.appendChild(bar);

  var progress = 0;
  var timer = null;

  function startBar() {
    progress = 0;
    bar.style.opacity = '1';
    bar.style.width = '0%';
    bar.style.transition = 'width 0.3s ease, opacity 0.4s ease';
    // Animate to 80% quickly, then slow down
    setTimeout(function() { bar.style.width = '70%'; bar.style.transition = 'width 8s ease'; }, 10);
  }

  function finishBar() {
    bar.style.transition = 'width 0.2s ease, opacity 0.5s ease 0.2s';
    bar.style.width = '100%';
    setTimeout(function() { bar.style.opacity = '0'; bar.style.width = '0%'; }, 600);
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('a');
    if (!el || !el.href || el.origin !== location.origin) return;
    if (/\/(cart|account\/logout|admin)/.test(el.pathname)) return;
    if (el.target === '_blank') return;
    startBar();
  });

  window.addEventListener('pageshow', finishBar);
  window.addEventListener('load', finishBar);
})();

// ============================================================
// HERO SLIDER
// ============================================================
document.addEventListener('DOMContentLoaded', function() {

  function initHeroSlider(sliderId, dotsSelector, prevId, nextId) {
    var slider = document.getElementById(sliderId);
    if (!slider) return;
    var slides = slider.children;
    var dots = document.querySelectorAll(dotsSelector);
    var current = 0;
    var total = slides.length;
    if (total <= 1) { dots.forEach(function(d){ d.style.display = 'none'; }); return; }
    var autoTimer;

    function goTo(n) {
      current = (n + total) % total;
      slider.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
    }

    function startAuto() { autoTimer = setInterval(function() { goTo(current + 1); }, 4000); }
    function resetAuto() { clearInterval(autoTimer); startAuto(); }

    if (prevId) {
      var prevBtn = document.getElementById(prevId);
      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); resetAuto(); });
    }
    if (nextId) {
      var nextBtn = document.getElementById(nextId);
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); resetAuto(); });
    }

    dots.forEach(function(d) {
      d.addEventListener('click', function() { goTo(parseInt(d.dataset.index)); resetAuto(); });
    });

    var touchStart = 0;
    slider.addEventListener('touchstart', function(e) { touchStart = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var diff = touchStart - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { goTo(diff > 0 ? current + 1 : current - 1); resetAuto(); }
    });

    startAuto();
  }

  // Homepage hero
  initHeroSlider('heroSlides', '.hero-dot', 'heroPrev', 'heroNext');
  // Devotional collection hero
  initHeroSlider('devotHeroSlides', '#devotHeroDots .devot-hero-dot', null, null);

  // ============ NAV DRAWER ============
  var menuBtn = document.getElementById('menu-toggle');
  var drawer = document.getElementById('nav-drawer');
  var overlay = document.getElementById('nav-overlay');
  var closeBtn = document.getElementById('nav-close');

  function openDrawer() { drawer.classList.add('open'); overlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('open'); overlay.classList.remove('active'); document.body.style.overflow = ''; }

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

});
